module.exports = __webpack_public_path__ + "b4935eaaf7a02560cad3d1555ab7e8d3.png";